<template>
  <div>
    <el-dialog
      :style="isMB?'margin-top: -13vh !important;':''"
      title="选择班级"
      :visible.sync="dialogVisible"
      width="280px"
      :before-close="handleClose"
    >
      <el-row>
        <el-col :span="6">
            <span style="vertical-align:-5px;">班级：</span>
        </el-col>
        <el-col :span="18">
          <!-- <el-input size="mini" v-model="SeatNumber" type="number" placeholder="请填写座位号"></el-input> -->
          <el-select v-model="ClassId" size="mini">
            <el-option v-for="item in classList" :key="item.ClassId" :value="item.ClassId" :label="item.ClassName"></el-option>
          </el-select>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="submit">保 存</el-button>
        <el-button @click="dialogVisible = false" size="small">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/api/ed/class";
export default {
  data() {
    return {
      ClassId: null,
      dialogVisible: false,
      GradeId: null,
      classList: [],
      isMB: this.$store.state.isMB,
      api,
    };
  },
  methods: {
    open(id) {
      this.GradeId = id || null
      this.dialogVisible = true
      this.api.list({ TermId: sessionStorage.getItem("termId") }).then(res => {
        this.classList = res.Data
      })
    },
    close() {
      this.dialogVisible = false
      this.ClassId = null
    },
    submit() {
      if(!this.ClassId) {
        this.$message.error("请选择班级")
        return false
      }
      this.$emit("setClass",this.ClassId)
    },
    handleClose() {}
  }
};
</script>

<style>
</style>